import { render, staticRenderFns } from "./withdrawal.vue?vue&type=template&id=ce147e6e"
import script from "./withdrawal.vue?vue&type=script&lang=js"
export * from "./withdrawal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports